import Head from "next/head";

import config from "config";
import { AuthLayout } from "auth";
import StackData from "modules/data-files/views/Stack-Data";

const Page = () => {
  return (
    <>
      <Head>
        <title>{config.SITE_NAME} | Stack Data Files</title>
      </Head>
      <div className="max-w-full mx-auto px-4 sm:px-6">
        <div className="pb-4 mb-8">
          <h1 className="h2 text-center">Stack Data Files</h1>
          <StackData />
        </div>
      </div>
    </>
  );
};

Page.getLayout = (page) => <AuthLayout>{page}</AuthLayout>;

export default Page;
